// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_GET_URL_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/getUrl.js");
var ___CSS_LOADER_URL_IMPORT_0___ = require("../../public/SiteIcons/calendarPrevIcon.svg");
var ___CSS_LOADER_URL_IMPORT_1___ = require("../../public/SiteIcons/calendarNextIcon.svg");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.adminSingleDatePickerContainer .SingleDatePickerInput {
    border-radius: var(--radius-1) !important;
    border: 1px solid var(--primary-border) !important;
    display: flex;
    padding: 0 !important;
    background-color: var(--primary-input-bg);
}

.adminSingleDatePickerContainer .SingleDatePickerInput_clearDate {
    padding: 10px !important;
    margin: 0 !important;
    top: 0px !important;
    -webkit-transform: none !important;
    transform: none !important;
    -ms-transform: none !important;
    position: unset;
    width: 45px;
    height: 45px;
}

.adminSingleDatePickerContainer .SingleDatePickerInput_clearDate:focus,
.adminSingleDatePickerContainer .SingleDatePickerInput_clearDate:hover {
    background: transparent !important;
    outline: unset;
}

.adminSingleDatePickerContainer .adminCalenderCustomCloseIcon {
    width: 24px;
    height: 24px;
    display: inline-block;
}

.adminSingleDatePickerContainer .SingleDatePickerInput__withBorder {
    border: 1px solid var(--primary-border) !important;
    border-radius: 4px !important;
}

.adminSingleDatePickerContainer .DateInput_input {
    border-radius: var(--radius-1) !important;
    border-bottom: 0 !important;
    padding: 12px 20px !important;
    font-size: 16px;
    line-height: 22px;
    font-weight: 400;
    height: 46px;
}

.adminSingleDatePickerContainer table tbody tr:hover {
    background-color: transparent !important;
}

.adminSingleDatePickerContainer .DayPicker__withBorder {
    border-radius: 4px !important;
}

.adminSingleDatePickerContainer .DateInput_input::placeholder {
    color: var(--primary-placeholder-foreground) !important;
}

.adminSingleDatePickerContainer .SingleDatePicker_picker {
    background-color: var(--primary-white-bg) !important;
    z-index: 1032;
    top: 100% !important;
    border-radius: 4px;
}

.adminSingleDatePickerContainer .DateInput_fang {
    display: none !important;
}

.adminSingleDatePickerContainer .DateInput {
    background-color: transparent !important;
}

.adminSingleDatePickerContainer .DayPicker__horizontal,
.adminSingleDatePickerContainer .CalendarMonthGrid,
.adminSingleDatePickerContainer .CalendarMonth {
    background-color: var(--primary-white-bg) !important;
}

.adminSingleDatePickerContainer .CalendarMonth_caption {
    color: var(--primary-foreground);
    font-size: 18px !important;
    line-height: 26px !important;
    font-weight: 400 !important;
    padding-top: 15px !important;
    padding-bottom: 44px !important;
}

.adminSingleDatePickerContainer .DayPickerNavigation_button,
.adminSingleDatePickerContainer .DayPickerNavigation_button:active {
    background-color: var(--primary-white-bg) !important;
    border-radius: 50% !important;
    border: 1px solid var(--primary-border) !important;
    width: 100%;
    max-width: 36px;
    min-width: 36px;
    height: 36px;
    min-height: 36px;
    top: 10px !important;
}

.adminSingleDatePickerContainer .DayPickerNavigation_leftButton__horizontalDefault,
.adminSingleDatePickerContainer .DayPickerNavigation_rightButton__horizontalDefault {
    background-repeat: no-repeat !important;
    background-size: 24px !important;
    background-position: center !important;
}

.adminSingleDatePickerContainer .DayPickerNavigation_leftButton__horizontalDefault {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) !important;
}

.adminSingleDatePickerContainer .DayPickerNavigation_rightButton__horizontalDefault {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) !important;
}

.adminSingleDatePickerContainer .DayPickerNavigation_svg__horizontal,
.adminSingleDatePickerContainer .DayPickerNavigation_svg__horizontal_1 {
    display: none !important;
}

.adminSingleDatePickerContainer .CalendarDay__selected,
.adminSingleDatePickerContainer .CalendarDay__selected:active,
.adminSingleDatePickerContainer .CalendarDay__selected:hover {
    background: var(--calendar-active-bg) !important;
    color: var(--calendar-active-foreground) !important;
}


.adminSingleDatePickerContainer .CalendarDay__blocked_out_of_range,
.adminSingleDatePickerContainer .CalendarDay__blocked_out_of_range:active,
.adminSingleDatePickerContainer .CalendarDay__blocked_out_of_range:hover {
    background: var(--calendar-disabled-bg);
    color: var(--calendar-disable-foreground);
    cursor: not-allowed;
}

.adminSingleDatePickerContainer .CalendarDay__default:hover:not(.CalendarDay__blocked_out_of_range):not(.CalendarDay__selected):not(.CalendarDay__selected_span):not(.CalendarDay__highlighted_calendar):not(.CalendarDay__blocked_calendar) {
    background-color: var(--calendar-hover) !important;
    color: var(--calendar-active-foreground);
}`, "",{"version":3,"sources":["webpack://./src/styles/reactSingleDatesCalendar.css"],"names":[],"mappings":"AAAA;IACI,yCAAyC;IACzC,kDAAkD;IAClD,aAAa;IACb,qBAAqB;IACrB,yCAAyC;AAC7C;;AAEA;IACI,wBAAwB;IACxB,oBAAoB;IACpB,mBAAmB;IACnB,kCAAkC;IAClC,0BAA0B;IAC1B,8BAA8B;IAC9B,eAAe;IACf,WAAW;IACX,YAAY;AAChB;;AAEA;;IAEI,kCAAkC;IAClC,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,qBAAqB;AACzB;;AAEA;IACI,kDAAkD;IAClD,6BAA6B;AACjC;;AAEA;IACI,yCAAyC;IACzC,2BAA2B;IAC3B,6BAA6B;IAC7B,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,YAAY;AAChB;;AAEA;IACI,wCAAwC;AAC5C;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,uDAAuD;AAC3D;;AAEA;IACI,oDAAoD;IACpD,aAAa;IACb,oBAAoB;IACpB,kBAAkB;AACtB;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,wCAAwC;AAC5C;;AAEA;;;IAGI,oDAAoD;AACxD;;AAEA;IACI,gCAAgC;IAChC,0BAA0B;IAC1B,4BAA4B;IAC5B,2BAA2B;IAC3B,4BAA4B;IAC5B,+BAA+B;AACnC;;AAEA;;IAEI,oDAAoD;IACpD,6BAA6B;IAC7B,kDAAkD;IAClD,WAAW;IACX,eAAe;IACf,eAAe;IACf,YAAY;IACZ,gBAAgB;IAChB,oBAAoB;AACxB;;AAEA;;IAEI,uCAAuC;IACvC,gCAAgC;IAChC,sCAAsC;AAC1C;;AAEA;IACI,oEAA0E;AAC9E;;AAEA;IACI,oEAA0E;AAC9E;;AAEA;;IAEI,wBAAwB;AAC5B;;AAEA;;;IAGI,gDAAgD;IAChD,mDAAmD;AACvD;;;AAGA;;;IAGI,uCAAuC;IACvC,yCAAyC;IACzC,mBAAmB;AACvB;;AAEA;IACI,kDAAkD;IAClD,wCAAwC;AAC5C","sourcesContent":[".adminSingleDatePickerContainer .SingleDatePickerInput {\n    border-radius: var(--radius-1) !important;\n    border: 1px solid var(--primary-border) !important;\n    display: flex;\n    padding: 0 !important;\n    background-color: var(--primary-input-bg);\n}\n\n.adminSingleDatePickerContainer .SingleDatePickerInput_clearDate {\n    padding: 10px !important;\n    margin: 0 !important;\n    top: 0px !important;\n    -webkit-transform: none !important;\n    transform: none !important;\n    -ms-transform: none !important;\n    position: unset;\n    width: 45px;\n    height: 45px;\n}\n\n.adminSingleDatePickerContainer .SingleDatePickerInput_clearDate:focus,\n.adminSingleDatePickerContainer .SingleDatePickerInput_clearDate:hover {\n    background: transparent !important;\n    outline: unset;\n}\n\n.adminSingleDatePickerContainer .adminCalenderCustomCloseIcon {\n    width: 24px;\n    height: 24px;\n    display: inline-block;\n}\n\n.adminSingleDatePickerContainer .SingleDatePickerInput__withBorder {\n    border: 1px solid var(--primary-border) !important;\n    border-radius: 4px !important;\n}\n\n.adminSingleDatePickerContainer .DateInput_input {\n    border-radius: var(--radius-1) !important;\n    border-bottom: 0 !important;\n    padding: 12px 20px !important;\n    font-size: 16px;\n    line-height: 22px;\n    font-weight: 400;\n    height: 46px;\n}\n\n.adminSingleDatePickerContainer table tbody tr:hover {\n    background-color: transparent !important;\n}\n\n.adminSingleDatePickerContainer .DayPicker__withBorder {\n    border-radius: 4px !important;\n}\n\n.adminSingleDatePickerContainer .DateInput_input::placeholder {\n    color: var(--primary-placeholder-foreground) !important;\n}\n\n.adminSingleDatePickerContainer .SingleDatePicker_picker {\n    background-color: var(--primary-white-bg) !important;\n    z-index: 1032;\n    top: 100% !important;\n    border-radius: 4px;\n}\n\n.adminSingleDatePickerContainer .DateInput_fang {\n    display: none !important;\n}\n\n.adminSingleDatePickerContainer .DateInput {\n    background-color: transparent !important;\n}\n\n.adminSingleDatePickerContainer .DayPicker__horizontal,\n.adminSingleDatePickerContainer .CalendarMonthGrid,\n.adminSingleDatePickerContainer .CalendarMonth {\n    background-color: var(--primary-white-bg) !important;\n}\n\n.adminSingleDatePickerContainer .CalendarMonth_caption {\n    color: var(--primary-foreground);\n    font-size: 18px !important;\n    line-height: 26px !important;\n    font-weight: 400 !important;\n    padding-top: 15px !important;\n    padding-bottom: 44px !important;\n}\n\n.adminSingleDatePickerContainer .DayPickerNavigation_button,\n.adminSingleDatePickerContainer .DayPickerNavigation_button:active {\n    background-color: var(--primary-white-bg) !important;\n    border-radius: 50% !important;\n    border: 1px solid var(--primary-border) !important;\n    width: 100%;\n    max-width: 36px;\n    min-width: 36px;\n    height: 36px;\n    min-height: 36px;\n    top: 10px !important;\n}\n\n.adminSingleDatePickerContainer .DayPickerNavigation_leftButton__horizontalDefault,\n.adminSingleDatePickerContainer .DayPickerNavigation_rightButton__horizontalDefault {\n    background-repeat: no-repeat !important;\n    background-size: 24px !important;\n    background-position: center !important;\n}\n\n.adminSingleDatePickerContainer .DayPickerNavigation_leftButton__horizontalDefault {\n    background-image: url('/public/SiteIcons/calendarPrevIcon.svg') !important;\n}\n\n.adminSingleDatePickerContainer .DayPickerNavigation_rightButton__horizontalDefault {\n    background-image: url('/public/SiteIcons/calendarNextIcon.svg') !important;\n}\n\n.adminSingleDatePickerContainer .DayPickerNavigation_svg__horizontal,\n.adminSingleDatePickerContainer .DayPickerNavigation_svg__horizontal_1 {\n    display: none !important;\n}\n\n.adminSingleDatePickerContainer .CalendarDay__selected,\n.adminSingleDatePickerContainer .CalendarDay__selected:active,\n.adminSingleDatePickerContainer .CalendarDay__selected:hover {\n    background: var(--calendar-active-bg) !important;\n    color: var(--calendar-active-foreground) !important;\n}\n\n\n.adminSingleDatePickerContainer .CalendarDay__blocked_out_of_range,\n.adminSingleDatePickerContainer .CalendarDay__blocked_out_of_range:active,\n.adminSingleDatePickerContainer .CalendarDay__blocked_out_of_range:hover {\n    background: var(--calendar-disabled-bg);\n    color: var(--calendar-disable-foreground);\n    cursor: not-allowed;\n}\n\n.adminSingleDatePickerContainer .CalendarDay__default:hover:not(.CalendarDay__blocked_out_of_range):not(.CalendarDay__selected):not(.CalendarDay__selected_span):not(.CalendarDay__highlighted_calendar):not(.CalendarDay__blocked_calendar) {\n    background-color: var(--calendar-hover) !important;\n    color: var(--calendar-active-foreground);\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
